import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY, // "AIzaSyDukJM8gBNyhNVtEmSnwbTSRM6XErp5d_E",
  authDomain: "ce-portal-757fd.firebaseapp.com",
  projectId: "ce-portal-757fd",
  appId: "1:910368892066:web:f49da226f81e3877cb23fb",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Keep auth behavior consistent across member and linguist portals.
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn("Failed to set Firebase auth persistence to local:", error);
});

export { app, auth };
